<h3>{{year}} - {{formatShowedState(isEstimated) | translate}}</h3>
<section class="main-chart">
    <ng-container *ngFor="let kpi of kpis; index as i">
        <div *ngIf="i < maxNumber"
            [ngClass]="{
                alone: isAlone,
                inside: i === 1,
                negative: kpi.ratio.value < 0
            }">
            <app-gauge class="gauge-component"
                [value]="kpi.ratio.value"
                [strokeWidth]="i === 0 ? 7 : 5"
                [isDarken]="i === 0"></app-gauge>

            <div class="chart-label" [matTooltip]="kpi.text?.summary">
                <p>
                    {{kpi.text?.shortLabel}}
                </p>
                <div class="value">{{ kpi.ratio.value | formatPercent}}</div>
                <div class="value amount" *ngIf="isAlone">{{ kpi.amount.value | formatAmount: 'auto'}}</div>
            </div>
        </div>
    </ng-container>
</section>
